import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CapacityPlanningActions } from './capacity-planning.actions';
import { CapacityPlanningService } from '../../service/capacity-planning.service';
import { PlanningPanelService } from '../../service/planning-panel-service';
import { ActivityValueChainService } from '../../service/activity-value-chain.service';


@Injectable()
export class CapacityPlanningEffects {

  loadCapacityPlanning$ = createEffect(
    (rs: CapacityPlanningService = inject(CapacityPlanningService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.loadCapacityPlanning),
        mergeMap(({ parameters, campaignId }) =>
          rs.getCapacityPlanning(campaignId, parameters).pipe(
            mergeMap((capacityPlanning) => [
              CapacityPlanningActions.loadCapacityPlanningSuccess({ capacityPlanning })
            ]),
            catchError((error) => of(CapacityPlanningActions.loadCapacityPlanningFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadCapacityPlanninFilters$ = createEffect(
    (rs: CapacityPlanningService = inject(CapacityPlanningService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.loadAllCapacityPlanning),
        mergeMap(({ parameters, campaignId }) =>
          rs.getCapacityPlanning(campaignId, parameters).pipe(
            mergeMap((allCapacityPlanning) => [
              CapacityPlanningActions.loadAllCapacityPlanningSuccess({ allCapacityPlanning })
            ]),
            catchError((error) => of(CapacityPlanningActions.loadAllCapacityPlanningFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  getYears$ = createEffect(
    (rs: PlanningPanelService = inject(PlanningPanelService)) => {
      return this.actions$.pipe(

        ofType(CapacityPlanningActions.getYears),
        mergeMap(() =>
          rs.getYears().pipe(
            map((years) => {
              return CapacityPlanningActions.getYearsSuccess({
                years
              });
            }),
            catchError((error) => of(CapacityPlanningActions.getYearsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  loadCampaigns$ = createEffect(
    (aS: ActivityValueChainService = inject(ActivityValueChainService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.loadCampaigns),
        mergeMap(({ campaignType }) =>
          aS.getActivityValueChainsCampaigns(campaignType).pipe(
            map((campaigns) => {
              return CapacityPlanningActions.loadCampaignsSuccess({
                campaigns
              });
            }),
            catchError((error) => of(CapacityPlanningActions.loadCampaignsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  validateCapacityPlanning$ = createEffect(
    (cp: CapacityPlanningService = inject(CapacityPlanningService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.validateCapacityPlanning),
        mergeMap(({ capacityLegalEntityId }) =>
          cp.validateCapacityPlanning(capacityLegalEntityId).pipe(
            map((capacityPlanning) => {
              return CapacityPlanningActions.validateCapacityPlanningSuccess({
                capacityPlanning
              });
            }),
            catchError((error) => of(CapacityPlanningActions.validateCapacityPlanningFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  createCampaign$ = createEffect(
    (rs: CapacityPlanningService = inject(CapacityPlanningService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.createCampaigns),
        mergeMap(({ campaignType, year }) =>
          rs.createCampaign(year, campaignType).pipe(
            mergeMap((campaign) => [
              CapacityPlanningActions.createCampaignsSuccess({ campaign }),
              CapacityPlanningActions.loadCapacityPlanning({ campaignId: campaign.data?.id as string, parameters: { page: 0, rows: 25 } })
            ]),
            catchError((error) => of(CapacityPlanningActions.createCampaignsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  updateCampaign$ = createEffect(
    (cp: CapacityPlanningService = inject(CapacityPlanningService)) => {
      return this.actions$.pipe(
        ofType(CapacityPlanningActions.updateCampaigns),
        mergeMap(({ id, status }) =>
          cp.updateCampaign(id, status).pipe(
            map((campaign) => {
              return CapacityPlanningActions.updateCampaignsSuccess({
                campaign
              });
            }),
            catchError((error) => of(CapacityPlanningActions.updateCampaignsFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
